/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input, OnDestroy, OnInit, ViewChildren, ChangeDetectionStrategy } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DTypeForm, DTypeFormArray, DTypeTableWithRatingLinkedField } from '@grupo-constant/next-dtype/form';
import { CODEBARSCANNERWITHSELECT_URI, DTypeViewableCol, SELECTFACADE_COLUMN_URI, SELECTFROMCONCEPTSERVICE_COLUMN_URI, SELECTFROMENUMERATION_COLUMN_URI, SELECTFROMMASTERDATA_COLUMN_URI, SELECTFROMNEXTSERVICIOPLANNINGAREA_COLUMN_URI, SELECTFROMRESOURCESCANNER_URI, SELECTFROMURI_COLUMN_URI, SELECTMASTER_COLUMN_URI, SELECTNEXTTASKTYPE_COLUMN_URI, SELECTWITHGIVENOPTIONS_COLUMN_URI } from '@grupo-constant/next-dtype/types';
import { TranslocoService } from '@ngneat/transloco';
import { isArray } from 'lodash-es';
import { Subject, Subscription } from 'rxjs';
import { DTypeFormFieldComponent } from '../../dtype-field.model';
import { LocaleString } from '../../../translate/localeString.model';
import { DTypeService } from '../../dtype.service';
import { Events } from '../../../events/events.service';
import { LocalizePipe } from '../../../pipes/localize.pipe';
import { FuseConfirmationService } from '../../../../../@fuse/services/confirmation/confirmation.service';
import { DialogsService } from '../../../../dialogs/dialogs.service';

@Component({
    selector: 'table-with-rating-linked-field-component',
    templateUrl: './table-with-rating-linked-field.component.html',
    styles: [
        /* language=SCSS */
        `
            .error-panel {
                border-style: solid;
                border-width: 1px;
                border-color: red;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypeTableWithRatingLinkedComponent implements OnInit, OnDestroy, DTypeFormFieldComponent {
    @ViewChildren(MatExpansionPanel) panels: MatExpansionPanel;

    @Input() field: DTypeTableWithRatingLinkedField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    panel: number;
    oldPanel: number;
    canAddRow: boolean = true;
    rowsSave: number[] = [];
    saving: boolean = false;

    tableHeader: LocaleString[] = [];
    tableData: any[][] = [];

    urisSelects = [
        SELECTFACADE_COLUMN_URI,
        SELECTFROMCONCEPTSERVICE_COLUMN_URI,
        SELECTFROMENUMERATION_COLUMN_URI,
        SELECTFROMRESOURCESCANNER_URI,
        SELECTFROMURI_COLUMN_URI,
        SELECTMASTER_COLUMN_URI,
        SELECTWITHGIVENOPTIONS_COLUMN_URI,
        SELECTFROMMASTERDATA_COLUMN_URI,
        SELECTFROMNEXTSERVICIOPLANNINGAREA_COLUMN_URI,
        SELECTNEXTTASKTYPE_COLUMN_URI,
        CODEBARSCANNERWITHSELECT_URI
    ];

    editView: boolean = false;
    required: boolean = false;

    total: any[];

    eventSubscription: Subscription;
    private _unsubscribeAll = new Subject<void>();

    constructor(
        private dtypeService: DTypeService,
        private events: Events,
        private localize: LocalizePipe,
        private fuseConfirmationService: FuseConfirmationService,
        private transloco: TranslocoService,
        private snackBar: MatSnackBar,
        private dialogsService: DialogsService,
    ) { }

    async ngOnInit() {
        if (this.field.minRows > 0) {
            this.required = true;
        }

        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }

        if (this.field.embeddedForms.length === 0 && this.required) {
            const newEmbeddedForm = this.dtypeService.getDtypeFormFromDtype(this.field.table.dtype, { isUpdate: this.isUpdate });
            if (newEmbeddedForm) {
                this.field.embeddedForms.push(newEmbeddedForm);
                (this.field.control as DTypeFormArray).push(newEmbeddedForm.control);
                newEmbeddedForm.control.valueChanges.subscribe((value) => {
                    if (value) {
                        this.rowsSave = this.rowsSave.filter(r => r !== 0);
                    }
                });
            }
            this.panel = 0;
            this.oldPanel = 0;
        }
        this.createTableView();

        this.eventSubscription = this.events.subscribe('createAC', (data: { name: string }) => {
            const index = this.field.control.getRawValue().findIndex((v: { field_name: string }) => v.field_name === data.name);
            this.editView = true;
            if (index > -1) {

            } else {
                this.addItem(data.name);
            }
        });
    }

    ngOnDestroy() {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        this.eventSubscription.unsubscribe();
        this.events.destroy('createAC');
    }

    someRowHasError() {
        for (const embeddedForms of this.field.embeddedForms) {
            if (!embeddedForms.control.valid && embeddedForms.control.touched) {
                return true;
            }
        }
        return false;
    }

    controlHasErrors(form: DTypeForm) {
        return form.control.touched && !form.control.valid;
    }

    async addItem(name: string) {
        if (this.panel !== undefined) {
            this.oldPanel = this.panel;
            if (!this.rowsSave.some(r => r === this.panel)) {
                this.saveItem(this.field.embeddedForms[this.panel], this.panel);
            }
            this.panels['_results'][this.panel]._expanded = false;
        }
        if (this.canAddRow) {
            const newEmbeddedForm = this.dtypeService.getDtypeFormFromDtype(this.field.table.dtype, { field_name: name }, { isUpdate: this.isUpdate });
            if (newEmbeddedForm) {
                this.field.embeddedForms.push(newEmbeddedForm);
                (this.field.control as DTypeFormArray).push(newEmbeddedForm.control);
                newEmbeddedForm.control.valueChanges.subscribe((value) => {
                    if (value) {
                        const index = this.panel;
                        if (index > -1) {
                            this.rowsSave = this.rowsSave.filter(r => r !== index);
                        }
                    }
                });
            }
            this.panel = this.panels['_results'].length;
            this.panels['_results'][this.panel]._expanded = true;
            this.canAddRow = false;
            if (this.field.embeddedForms.length > 0 && this.field.embeddedForms.length >= this.field.minRows) {
                this.field.control.setErrors({'incorrect': false});
                this.field.control.updateValueAndValidity();
            } else {
                this.field.control.setErrors({'incorrect': true});
            }
        }
    }

    async saveItem(form: DTypeForm, index: number) {
        this.saving = true;
        let saved: boolean = false;
        const repeated: boolean = false;
        let indexRepeated: number;
        form.control.markAllAsTouched();
        if (form.control.valid || (!form.control.valid && this.field.readonly || this.field.control.disabled)) {
            saved = true;
        } else {
            this.panels['_results'][index]._expanded = true;
            this.panels['_results'][this.panel]._expanded = false;
            this.panel = index;
            this.dialogsService.openErrorDialog({
                message: this.transloco.translate('errorsInForm')
            });
        }

        if (saved) {
            this.canAddRow = true;
            const ind = repeated ? indexRepeated : index;
            if (!this.rowsSave.some(r => r === ind)) {
                this.rowsSave.push(index);
            }
            if (form.control.valid) {
                this.snackBar.open(this.transloco.translate('rowSaved'), this.transloco.translate('accept'), { duration: 3000 });
            }
        } else {
            this.canAddRow = false;
        }
        this.saving = false;
        if (this.field.embeddedForms.length > 0 && this.field.embeddedForms.length >= this.field.minRows) {
            this.field.control.setErrors({'incorrect': false});
            this.field.control.updateValueAndValidity();
        } else {
            this.field.control.setErrors({'incorrect': true});
        }
    }

    async setPanel(index: number) {
        this.panel = index;
    }

    chooseOption(form: DTypeForm) {
        const caption = form.control.getRawValue()?.field_name;
        return caption;
    }

    async removeItem(index: number, str: string = undefined) {
        if (!str) {
            const confirm = await this.openConfirmDialog(this.transloco.translate('removeExistingRow'), this.transloco.translate('accept'),
                this.transloco.translate('cancel'));
            if (confirm) {
                this.field.embeddedForms.splice(index, 1);
                this.rowsSave.splice(index, 1);
                this.panels['_results'].splice(index, 1);
                (this.field.control as DTypeFormArray).removeAt(index);
                this.panel = this.panels['_results'].length - 1;
            }
        } else {
            this.field.embeddedForms.splice(index, 1);
            this.rowsSave.splice(index, 1);
            (this.field.control as DTypeFormArray).removeAt(index);
        }
        this.canAddRow = true;
    }


    async closePanel(index: number) {
        const saved = this.rowsSave.some(r => r === index);
        if (!saved && !this.saving) {
            this.panels['_results'][index]._expanded = true;
            await this.saveItem(this.field.embeddedForms[index], index);
            if (!this.rowsSave.some(r => r === index)) {
                for (const row of this.rowsSave) {
                    if (row !== index) {
                        this.panels['_results'][row]._expanded = false;
                    }
                }
                if (this.panel === index) {
                    this.panels['_results'][index]._expanded = true;
                }
            } else {
                this.panels['_results'][index]._expanded = false;
            }
        }
        this.oldPanel = index;
    }

    createTableView() {
        this.tableData = [];
        this.tableHeader = [];
        this.editView = false;
        if (this.field.embeddedForms.length > 0) {
            for (const field of Object.values(this.field.embeddedForms[0].fields)) {
                this.tableHeader.push(field.label);
            }
        }
        for (const form of this.field.embeddedForms) {
            const values: any[] = [];
            let value;
            for (const column of form.dType.column) {
                const index = form.dType.column.findIndex(c => c === column);
                if (index > -1) {
                    if (column.type === SELECTWITHGIVENOPTIONS_COLUMN_URI || column.type === SELECTFROMURI_COLUMN_URI
                        || column.type === CODEBARSCANNERWITHSELECT_URI) {
                        value = this.localize.transform(column['option']?.find(o => o.code === Object.values(form.control.value)[index])?.value);
                        values.push(value);
                    } else {
                        value = Object.values(form.control.value)[index];
                        values.push(value);
                    }
                }
            }
            this.tableData.push(values);
            if (this.field.embeddedForms.length > 0 && this.field.embeddedForms.length < this.field.minRows) {
                this.field.control.setErrors({'incorrect': true});
            } else {
                this.field.control.setErrors({'incorrect': false});
                this.field.control.updateValueAndValidity();
            }
        }
    }

    transformRowValue(rowValue) {
        if (typeof rowValue === 'object') {
            if (rowValue && Object.keys(rowValue).includes('es-ES')) {
                return this.localize.transform(rowValue);
            }
            if (rowValue?.placeId) {
                return rowValue.name;
            }
            if (isArray(rowValue) && rowValue.length > 0 && typeof rowValue[0] !== 'object') {
                return rowValue.join(', ');
            }
        }
        if (typeof rowValue === 'boolean') {
            if (rowValue) {
                rowValue = this.transloco.translate('true');
            } else {
                rowValue = this.transloco.translate('false');
            }
        }
        return rowValue ?? '';
    }

    private openConfirmDialog(message: string, confirmButton: string, cancelButton: string) {
        const dialogRef = this.fuseConfirmationService.open({
            title: this.transloco.translate('warning'),
            message: this.transloco.translate(message),
            actions: {
                confirm: {
                    label: this.transloco.translate(confirmButton)
                },
                cancel: {
                    label: this.transloco.translate(cancelButton)
                }
            }
        });

        return new Promise<boolean>((resolve) => {
            dialogRef.afterClosed().subscribe(result => resolve(result === 'confirmed'));
        });
    }

}


